module.exports = __webpack_public_path__ + "img/nav-estadisticas.447865f0.svg";